var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRugbyUnion = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "American-Football-Ball--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "American Football Ball Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 17a4.5 7 0 1 0 9 0 4.5 7 0 1 0 -9 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.67 13.76a0.5 0.5 0 0 1 -0.17 -0.38V1a1 1 0 0 0 -2 0v8a0.5 0.5 0 0 1 -0.5 0.5h-7a0.5 0.5 0 0 1 -0.5 -0.5V1a1 1 0 0 0 -2 0v12.38a0.5 0.5 0 0 1 -0.17 0.38 1 1 0 0 0 -0.33 0.74V19a0.5 0.5 0 0 0 0.5 0.5h2a0.5 0.5 0 0 0 0.5 -0.5v-4.5a1 1 0 0 0 -0.33 -0.74 0.5 0.5 0 0 1 -0.17 -0.38V12a0.5 0.5 0 0 1 0.5 -0.5h7a0.5 0.5 0 0 1 0.5 0.5v1.38a0.5 0.5 0 0 1 -0.17 0.38 1 1 0 0 0 -0.33 0.74V19a0.5 0.5 0 0 0 0.5 0.5h2a0.5 0.5 0 0 0 0.5 -0.5v-4.5a1 1 0 0 0 -0.33 -0.74Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRugbyUnion);
export default ForwardRef;